// removed by extract-text-webpack-plugin
module.exports = {"layout-compact-wrapper":"layout-compact-wrapper___4EmeY","layout-compact-main":"layout-compact-main___2nLph","layout-compact-content-wrapper":"layout-compact-content-wrapper___297cm","layout-compact-content":"layout-compact-content___3ccMr"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/layout-compact/layout-compact.module.scss
// module id = 1350
// module chunks = 82